import { useEffect, useState } from 'react';

export function ReviewStars({ rating, size = 'md', hideLabel = false }) {
  const n = Math.max(1, Math.min(5, Number(rating) || 5));
  const cls = size === 'sm' ? 'product-reviews-stars product-reviews-stars--sm' : 'product-reviews-stars';
  return (
    <span className={cls} aria-hidden={hideLabel ? 'true' : undefined} aria-label={hideLabel ? undefined : `${n} out of 5 stars`}>
      {'★'.repeat(n)}
      <span className="product-reviews-stars__empty">{'☆'.repeat(5 - n)}</span>
    </span>
  );
}

/** Lightweight summary for buy box (no auth). */
export function useProductReviewSummary(categorySlug, productId) {
  const [state, setState] = useState({ loading: true, average: 0, count: 0 });

  useEffect(() => {
    let cancelled = false;
    const qs = new URLSearchParams({
      category_slug: categorySlug,
      product_id: String(productId),
    });
    fetch(`/api/reviews.php?${qs}`)
      .then((r) => r.json())
      .then((d) => {
        if (cancelled || !d.success) return;
        setState({
          loading: false,
          average: Number(d.average) || 0,
          count: Number(d.count) || 0,
        });
      })
      .catch(() => {
        if (!cancelled) setState({ loading: false, average: 0, count: 0 });
      });
    return () => {
      cancelled = true;
    };
  }, [categorySlug, productId]);

  return state;
}
